var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 2.03421L9.99999 2.32635L9.70702 2.03338C8.69509 1.03988 7.33178 0.486152 5.91367 0.492668C4.49557 0.499184 3.13741 1.06541 2.13464 2.06817C1.13188 3.07094 0.565655 4.4291 0.559139 5.8472C0.552623 7.26531 1.10635 8.62862 2.09985 9.64055L2.39282 9.93352L9.99999 17.5407L17.6072 9.93352L17.9001 9.64055C18.8857 8.62704 19.4327 7.26627 19.4228 5.85258C19.4129 4.43888 18.8469 3.08591 17.8472 2.0863C16.8475 1.0867 15.4945 0.520824 14.0808 0.511075C12.6671 0.501325 11.3064 1.04849 10.293 2.03421Z",
    fill: "#6B8E76"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.293 5.03421L12 5.32635L11.707 5.03338C10.6951 4.03988 9.33178 3.48615 7.91367 3.49267C6.49557 3.49918 5.13741 4.06541 4.13464 5.06817C3.13188 6.07094 2.56565 7.4291 2.55914 8.8472C2.55262 10.2653 3.10635 11.6286 4.09985 12.6406L4.39282 12.9335L12 20.5407L19.6072 12.9335L19.9001 12.6406C20.8857 11.627 21.4327 10.2663 21.4228 8.85258C21.4129 7.43888 20.8469 6.08591 19.8472 5.0863C18.8475 4.0867 17.4945 3.52082 16.0808 3.51107C14.6671 3.50133 13.3064 4.04849 12.293 5.03421Z",
    fill: "#6B8E76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartDark);
export default __webpack_public_path__ + "static/media/HeartDark.44b0c888e2e2756dc52de239cceac595.svg";
export { ForwardRef as ReactComponent };